import { useCallback, useEffect, useState } from 'react';
import { TrainingActionGroupService } from '../../services/training-action-group/trainingActionGroupService';

const useTrainingActionGroups = (initialFilters = {}) => {
    const [data, setData] = useState<any[]>([]);
    const [filters, setFilters] = useState({
        limit: 999999,
        filter_filters: { ...initialFilters }
    });

    const fetchTrainingActionGroups = async (extraFilters: any = null) => {
        try {
            const service = new TrainingActionGroupService();
            const response = await service.listForSelect(extraFilters ?? filters);
            const fetchedData = response.getResponseData()?.data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((item: { id: string; name: string; code: string }) => ({
                    value: item.id,
                    label: `${item.code} - ${item.name}`,
                    code: item.code,
                    name: item.name,
                }));
                setData(mappedData);
            } else {
                setData([]);
            }
        } catch (error) {
            console.log('Error fetching training action groups:', error);
            setData([]);
        }
    };

    useEffect(() => {
        fetchTrainingActionGroups();
    }, [filters]);

    const updateTrainingActionGroupsHookFilters = useCallback((newFilters: any) => {
        setFilters((prevFilters: any) => ({
            ...prevFilters,
            filter_filters: {
                ...(prevFilters?.filter_filters ?? {}),
                ...newFilters,
            }
        }));
    }, []);

    const getTrainingActionGroupsList = () => data;

    return { fetchTrainingActionGroups, getTrainingActionGroupsList, updateTrainingActionGroupsHookFilters };
}

export default useTrainingActionGroups;

